export default __webpack_public_path__ + "static/media/delete.567729ba.svg";